class Helpers {
    constructor() {}

    twoDigitNumber(num) {
        if (!num) return 0
        return num.toFixed(2)
    }
}

export default new Helpers()
